import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  boxShadow,
  BoxShadowProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseHeaderProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    SpaceProps,
    TypographyProps,
    BoxShadowProps {
  overflowScrolling?: string;
  WebkitOverflowScrolling?: string;
}

type NonCollidingHeaderProps = WithoutCollidingProps<BaseHeaderProps, 'header'>;
type NonCollidingHeaderKeys = keyof NonCollidingHeaderProps;

export const Header = styled('header', {
  shouldForwardProp: (prop): prop is NonCollidingHeaderKeys =>
    shouldForwardProp(prop as NonCollidingHeaderKeys),
})<BaseHeaderProps>(
  defineWithTheme('headers'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography,
    boxShadow
  )
);

export type HeaderProps = React.ComponentPropsWithoutRef<typeof Header>;
